import React from "react"
import { Link, withRouter } from "react-router"
import { messages } from "../../messages/profile"
import {injectIntl, intlShape} from "react-intl";

const RegisterButton = ({ intl, location }) => (
  <Link to={{ pathname: "/register", query: location.query }}>
    <button className="button mtt" type="button">{ intl.formatMessage(messages.register) }</button>
  </Link>
);

RegisterButton.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(withRouter(RegisterButton))



// WEBPACK FOOTER //
// ./webapp/components/elements/RegisterButton.js